import generalSection from "../_section/section.class";
import {adminEDSUpload, userEDSUpload} from "./upload";
import DataForm from "./DataForm";
import ApplicationForm from "./ApplicationForm";
import dayjs from "dayjs";
import problem from "../_section/section-problem.class";
import {legacyIncome} from "../../../../../components/client/application-stages/_common/lender-tests/useXlsTests";

export class userEDSSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userEDSUpload);

        // Add missing date error

    }
}

export class adminEDSSection extends userEDSSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminEDSUpload);
        this.sortByDateProp('year')
        this.DataForm = DataForm
        this.ApplicationForm = ApplicationForm;
        this.setProblems(this.getProblems())
    }

    numberOfEdsNeeded = (n) => {
        const legacyEmployment = legacyIncome(this.mortgage)

        const applicant = this.mortgage[`applicant${n}`]
        let sum = 0
        if (legacyEmployment) {
            if (applicant.income.incomeChecks?.length) {
                if (applicant.income.incomeChecks.includes('OVERTIME')) {
                    sum += applicant.income.overtime
                }
                if (applicant.income.incomeChecks.includes('BONUS')) {
                    sum += applicant.income.bonus
                }
                if (applicant.income.incomeChecks.includes('COMMISSION')) {
                    sum += applicant.income.commission
                }
                if (applicant.income.incomeChecks.includes('ALLOWANCES')) {
                    sum += applicant.income.allowances
                }
                if (applicant.income.incomeChecks.includes('OTHER')) {
                    sum += applicant.income.other
                }
            }
        } else {
            applicant.employmentIncome.forEach(emp => {
                (emp.incomes || []).forEach(income => {
                    switch (income.name) {
                        case 'bonus':
                            sum += income?.yearMostRecent || income?.amount || 0
                            sum += income?.yearBefore || 0
                            sum += income?.yearBeforeThat || 0
                            break
                        case 'overtime':
                            sum += income?.yearMostRecent || income?.amount || 0
                            sum += income?.yearBefore || 0
                            sum += income?.yearBeforeThat || 0
                            break
                        case 'commission':
                            sum += income?.yearMostRecent || income?.amount || 0
                            sum += income?.yearBefore || 0
                            sum += income?.yearBeforeThat || 0
                            break
                        case 'shiftAllowance':
                            sum += income?.yearMostRecent || income?.amount || 0
                            sum += income?.yearBefore || 0
                            sum += income?.yearBeforeThat || 0
                            break
                        case 'otherAllowance':
                            sum += income?.yearMostRecent || income?.amount || 0
                            sum += income?.yearBefore || 0
                            sum += income?.yearBeforeThat || 0
                            break
                        case 'carAllowance':
                            sum += income?.yearMostRecent || income?.amount || 0
                            sum += income?.yearBefore || 0
                            sum += income?.yearBeforeThat || 0
                            break
                    }
                })
            })
        }
        return sum > 0 ? 3 : 1


        // const variableNames = ['shiftAllowance', 'carAllowance', 'otherAllowance', 'overtime', 'bonus', 'commission']
        // let claimedVariable = variableNames.some(name=>{
        //     return this.mortgage.calculatorFigures.unverified.figures[`applicant${n}`].jobs.some(job=>{
        //         if (!job?.[name]) return false
        //         return job?.[name] && (job[name].guaranteed && job[name].yearMostRecent > 0) || (!job?.[name].guaranteed && ((job[name].yearMostRecent||0) + (job[name].yearBefore ||0) + (job[name].yearBeforeThat||0)) > 0)
        //     })
        // })
        // return claimedVariable ? 3 : 1;
    }


    getProblems() {
        const problems = this.problemsList.universalVerifiedUploadProblems();
        if (!problems.length) {
            const noRequired = this.numberOfEdsNeeded(this.applicant)
            const thisYear = Number(dayjs().format("YYYY"))
            const yearsRequired = Array.from({length: noRequired}, (_, i) => (thisYear - (i + 1)).toString())
            const yearsHave = this.uploads.filter(u => u.isActive && u.isVerifiable && u.allValuesAnswered).map(u => u.values.year)
            const missingFromRequired = yearsRequired.filter(item => !yearsHave.includes(item))
            if (missingFromRequired.length > 0) {
                const pluralIfNeeded = missingFromRequired.length > 1 ? 's' : ''

                problems.push(new problem({
                    message: `Missing EDS for ${missingFromRequired.join(', ')}`,
                    type: "USER_ALERT",
                    name: 'MISSING_RECENT_EDS',
                    title: `Missing Employment Details Summary`,
                    body: `We need EDS${pluralIfNeeded} for ${missingFromRequired.join(', ')}`,
                }))
            }

        }
        return problems;
    }

    getSectionSummary = () => {
        const mostRecentEds = this.activeUploads.filter(u => u.isActive && u.isVerifiable && u.allValuesAnswered).sort((a, b) => {
            return Number(b.values.year) - Number(a.values.year)
        })[0]
        return ['1', '2', '3'].map(i => {
            const currTags = []
            if (mostRecentEds?.values?.[`start${i}`]) {
                currTags.push({
                    name: `Start Date`,
                    value: mostRecentEds?.values?.[`start${i}`]?.format('D MMM YYYY') || 'Not Provided'
                })
            }
            if (mostRecentEds?.values?.[`pay${i}`]) {
                currTags.push({
                    name: `Total Pay`,
                    value: mostRecentEds?.values?.[`pay${i}`] || 'Not Provided'
                })
            }
            if (!currTags.length) {
                return null
            }
            return {
                name: mostRecentEds?.values?.[`employer${i}`],
                tags: currTags
            }
        }).filter(n => !!n)
    }
}